import { useState, useEffect } from "react";

// Chakra imports
import {
  Box,
  SimpleGrid,
  useColorModeValue,
  Text,
  Portal,
  useDisclosure,
} from "@chakra-ui/react";

import { SidebarContext } from "contexts/SidebarContext";

import React from "react";

import Loader from "components/Loader";
import Navbar from "components/navbar/NavbarAdmin.js";

import Sidebar from "components/sidebar/Sidebar.js";
import {
  getActiveRoute,
  getActiveNavbar,
  getActiveNavbarText,
} from "helper/UploadFilePageHelper";

import routes from "routes.js";

import CheckTable from "views/admin/uploadFilePage/components/CheckTable";
import ComplexTable from "views/admin/uploadFilePage/components/ComplexTable";
import DailyTraffic from "views/admin/uploadFilePage/components/DailyTraffic";
import PieCard from "views/admin/uploadFilePage/components/PieCard";
import Tasks from "views/admin/uploadFilePage/components/Tasks";
import TotalSpent from "views/admin/uploadFilePage/components/TotalSpent";
import WeeklyRevenue from "views/admin/uploadFilePage/components/WeeklyRevenue";
import {
  columnsDataCheck,
  columnsDataComplex,
} from "views/admin/uploadFilePage/variables/columnsData";
import tableDataCheck from "views/admin/uploadFilePage/variables/tableDataCheck.json";
import tableDataComplex from "views/admin/uploadFilePage/variables/tableDataComplex.json";
import MiniCalendar from "components/calendar/MiniCalendar";

export default function AnalyticsPage() {
  // --------------------------------------
  const [loading, setLoading] = useState(false);
  const { onOpen } = useDisclosure();

  const textColor = useColorModeValue("secondaryGray.900", "white");

  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <Box>
          <Box>
            <SidebarContext.Provider>
              <Sidebar />
              <Box
                float="right"
                minHeight="100vh"
                height="100%"
                overflow="auto"
                position="relative"
                maxHeight="100%"
                w={{ base: "100%", xl: "calc( 100% - 290px )" }}
                maxWidth={{ base: "100%", xl: "calc( 100% - 290px )" }}
                transition="all 0.33s cubic-bezier(0.685, 0.0473, 0.346, 1)"
                transitionDuration=".2s, .2s, .35s"
                transitionProperty="top, bottom, width"
                transitionTimingFunction="linear, linear, ease"
              >
                <Portal>
                  <Box>
                    <Navbar
                      onOpen={onOpen}
                      logoText={"Horizon UI Dashboard PRO"}
                      brandText={getActiveRoute(routes)}
                      secondary={getActiveNavbar(routes)}
                      message={getActiveNavbarText(routes)}
                      fixed={false}
                      // {...rest}
                    />
                  </Box>
                </Portal>
                <Box
                  mx="auto"
                  p={{ base: "20px", md: "30px" }}
                  pe="20px"
                  minH="100vh"
                  pt="50px"
                >
                  <Box pt={{ base: "130px", md: "80px", xl: "80px" }}>
                    {/* <Text
                      color={textColor}
                      fontSize="2xl"
                      ms="24px"
                      fontWeight="700"
                      mb="24px"
                    >
                      Analytics
                    </Text> */}
                    <SimpleGrid
                      columns={{ base: 1, md: 2, xl: 2 }}
                      gap="20px"
                      mb="20px"
                    >
                      <TotalSpent />
                      <WeeklyRevenue />
                    </SimpleGrid>
                    <SimpleGrid
                      columns={{ base: 1, md: 1, xl: 2 }}
                      gap="20px"
                      mb="20px"
                    >
                      {/* <CheckTable
                        columnsData={columnsDataCheck}
                        tableData={tableDataCheck}
                      /> */}
                      <ComplexTable
                        columnsData={columnsDataComplex}
                        tableData={tableDataComplex}
                      />
                      <SimpleGrid
                        columns={{ base: 1, md: 2, xl: 2 }}
                        gap="20px"
                      >
                        <DailyTraffic />
                        <PieCard />
                      </SimpleGrid>
                    </SimpleGrid>
                    <SimpleGrid
                      columns={{ base: 1, md: 1, xl: 2 }}
                      gap="20px"
                      mb="20px"
                    >
                      {/* <CheckTable
                        columnsData={columnsDataCheck}
                        tableData={tableDataCheck}
                      /> */}
                      {/* <ComplexTable
                        columnsData={columnsDataComplex}
                        tableData={tableDataComplex}
                      /> */}
                      {/* <SimpleGrid
                        columns={{ base: 1, md: 2, xl: 2 }}
                        gap="20px"
                      >
                        <Tasks />
                        <MiniCalendar
                          h="100%"
                          minW="100%"
                          selectRange={false}
                        />
                      </SimpleGrid> */}
                    </SimpleGrid>
                  </Box>
                </Box>
              </Box>
            </SidebarContext.Provider>
          </Box>
        </Box>
      )}
    </>
  );
}
